export interface GooglePlayWicketOrder {
  item: {productTitle: string};
  createdAt: string;
  total: {currencyCode: string; nanos: number; units: number};
}

export interface GooglePlayWicketOrdersResponse {
  data: GooglePlayWicketOrder[];
  total: number;
}

export interface GooglePlayOrderResponse {
  data: {
    lineItems: {productTitle: string}[];
    createTime: string;
    total: {currencyCode: string; nanos: number; units: number};
  }[];
  total: number;
}
